var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLocked12 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.89543 2 4 2.89543 4 4V5C3.44772 5 3 5.44772 3 6V9C3 9.55228 3.44772 10 4 10H8C8.55228 10 9 9.55228 9 9V6C9 5.44772 8.55228 5 8 5V4C8 2.89543 7.10457 2 6 2ZM7 5V4C7 3.44772 6.55228 3 6 3C5.44772 3 5 3.44772 5 4V5H7Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocked12);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;